import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import estbn from '../assets/images/ESTBN.png'
import esCircle from "../assets/images/Smoll_ESTBN_Logo.png";
import {
  FaCalendarAlt,
  FaCogs,
  FaBell,
  FaSignOutAlt,
  FaUsers,
  FaTruck,
  FaClipboardList,
  FaTools,
  FaUserShield,
  FaWarehouse,
  FaArrowRight,
  FaArrowLeft,
} from "react-icons/fa";
import { MdDashboard } from "react-icons/md";
import "./Sidenav.css";
import { EmojiEvents, MiscellaneousServices, Percent } from "@mui/icons-material";
import { useSidebar } from "./SidebarProvider";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../redux/apicalls/authApiCall"; 
import { useNavigate } from "react-router-dom";
import { ChevronDown, ChevronUp, Package, Ticket } from "lucide-react";
import { useLocation } from "react-router-dom";

const SideNav = () => {

  const { user } = useSelector((state) => state.auth);

  const isStaff = user?.user_type === "stuff" || Boolean(user?.stuff);
  
  const [openMenus, setOpenMenus] = useState({});

  const { isSidebarOpen, toggleSidebar } = useSidebar();

  const stuffMenuItems = [
    { name: "الصفحة الرئيسية", icon: <MdDashboard />, path: "/Home" },
    // { name: "بدأ وانهاء الشيفت", icon: <FaClipboardList />, path: "/Home" },
    { name: "طلبات اليوم", icon: <FaUsers />, path: "/dayOrders" },
    {
      name: "بيانات و فحص السيارة",
      icon: <FaCalendarAlt />,
      path: "/checkCar",
    },
    { name: "طلب مساعدة علي الطريق", icon: <FaTools />, path: "/sos" },
       {
      name: "سجل الرحلات السابقة",
      icon: <FaUserShield />,
      path: "/trips",
    },
    {
      name: "الصفحة الشخصية",
      icon: <MiscellaneousServices />,
      path: "/profile",
    },
    { name: "الخروج", icon: <FaSignOutAlt />, path: "/logout" },
  ];

  const menuItems = [
    { name: "Dashboard", icon: <MdDashboard />, path: "/dashboard" },
    { name: "Orders", icon: <FaClipboardList />, path: "/orders" },
    { name: "Clients", icon: <FaUsers />, path: "/clients" },
    {
      name: "Vehicles",
      icon: <FaTruck />,
      children: [
        { name: "Doorstep Vehicles", path: "/vehicles" },
        { name: "Categories", path: "/vehiclesCategories" },
      ],
    },
    { name: "Calendar", icon: <FaCalendarAlt />, path: "/calendar" },
    {
      name: "Staff",
      icon: <FaUserShield />,
      children: [
        { name: "Operation", path: "/operation" },
        { name: "Technical", path: "/staff" },
        { name: "Expenses", path: "/expenses" },
        { name: "Notes", path: "/notes" },
      ],
    },
    {
      name: "User Requests  ",
      icon: <FaUserShield />,
      children: [
        { name: "Maintenance", path: "/maintenance" },
        { name: "Other Services", path: "/requests" },
      ],
    },
    { name: "Offers", icon: <Percent />, path: "/offers" },
    { name: "Bundles", icon: <Package />, path: "/bundles" },
    { name: "Coupons", icon: <Ticket />, path: "/coupons" },
    { name: "Reward System", icon: <EmojiEvents />, path: "/Rewards" },
    {
      name: "Stock",
      icon: <FaWarehouse />,
      children: [
        { name: "Categories", path: "/Categories" },
        { name: "Brands", path: "/Brands" },
        {
          name: "Manufacturers",
          path: "/manufacturers",
        },
        { name: "Products List", path: "/stock" },
        { name: "Vendors", path: "/stock/vendors" },
      ],
    },
    {
      name: "Notification",
      icon: <FaBell />,
      children: [
        { name: "Dashboard", path: "/NotifcationsDashboard" },
        { name: "Templates", path: "/Templates" },
        { name: "Categories", path: "/Notification Categories" },
        { name: "Campaigns", path: "/notificationCampaigns" },
        { name: "Automated Notify", path: "/AutomatedNotification" },
        { name: "User Groups", path: "/Usergroup" },
        { name: "Targeting Rules", path: "/targetingRules" },
        { name: "Circuit Breakers", path: "/CircuitBreakers" },
      ],
    },
    { name: "Equipments", icon: <FaTools />, path: "/equipments" },
    { name: "Services", icon: <MiscellaneousServices />, path: "/services" },
    { name: "Authorization", icon: <FaUserShield />, path: "/permissions" },
    { name: "Settings", icon: <FaCogs />, path: "/settings" },
    { name: "Log Out", icon: <FaSignOutAlt />, path: "/logout" },
  ];

  const [activeIndex, setActiveIndex] = useState(null);

  const toggleMenu = (index) => {
  setOpenMenus((prev) => {
    const closed = {};

    closed[index] = !prev[index];

    return closed;
  });

  setActiveIndex(index);
  };

  const isChildActive = (children) => {
    return children?.some((child) => location.pathname === child.path);
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
  menuItems.forEach((item, index) => {
    if (item.children && isChildActive(item.children)) {
      setOpenMenus((prev) => ({
        ...prev,
        [index]: true,
      }));
    }
  });
}, [location.pathname]);

  return (
    <div>
      <div className={`sidebar ${isSidebarOpen ? "open" : "closed"}`}>
        <div
          className={isSidebarOpen ? "arrow-close-toggle" : "arrow-open-toggle"}
          onClick={toggleSidebar}
        >
          {isSidebarOpen ? (
            <FaArrowLeft style={{ fontSize: "12px" }} />
          ) : (
            <FaArrowRight style={{ fontSize: "12px" }} />
          )}
        </div>
        <div className="sidebar-header" onClick={toggleSidebar}>
          <img
            src={isSidebarOpen ? estbn : esCircle}
            alt="Logo"
            className={isSidebarOpen ? "sideNav-logo" : "sideNav-close-logo"}
          />
        </div>
        {isStaff ? (
          <ul className="sidebar-menu" style={{  direction:"rtl"}}>
            {stuffMenuItems.map((item, index) => {
              if (item.children) {
                const isOpen = openMenus[index];
                return (
                  <li key={index} className="sidebar-item nested">
                    {/* Main Item */}
                    <div
                      className={`sidebar-link submenu-header ${
                        activeIndex === index ? "active-parent" : ""
                      }`}
                      onClick={() => toggleMenu(index)}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="submenu-main">
                        <span className="sideNav-icon">{item.icon}</span>

                        {isSidebarOpen && (
                          <span
                            className="sideNav-label text-ellipsis"
                            title={item.name}
                          >
                            {item.name}
                          </span>
                        )}
                      </div>

                      {/* Arrow */}
                      {isSidebarOpen && (
                        <span className="submenu-arrow">
                          {isOpen ? <ChevronUp /> : <ChevronDown />}
                        </span>
                      )}
                    </div>

                    {/* Sub Menu */}
                    {isSidebarOpen && isOpen && (
                      <ul className="sideNav-nested-menu">
                        {item.children.map((child, i) => (
                          <li key={i}>
                            <NavLink
                              to={child.path}
                              className="nested-link"
                              onClick={() => {
                                setActiveIndex(index);
                                setOpenMenus({ [index]: true });
                              }}
                            >
                              <span className="dot">•</span> {child.name}
                            </NavLink>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                );
              }
              if (item.name === "الخروج") {
                return (
                  <li key={index} className="sidebar-item">
                    <NavLink
                      to="/login"
                      className={`sidebar-link ${
                        activeIndex === index ? "active-parent" : ""
                      }`}
                      title={!isSidebarOpen ? item.name : ""}
                      onClick={(e) => {
                        e.preventDefault();
                        dispatch(logoutUser());
                        navigate("/login");
                      }}
                    >
                      <div className="submenu-main">
                        <span className="sideNav-icon">{item.icon}</span>

                        {isSidebarOpen && (
                          <span
                            className="sideNav-label text-ellipsis"
                            title={item.name}
                          >
                            {item.name}
                          </span>
                        )}
                      </div>
                    </NavLink>
                  </li>
                );
              }
              return (
                <li key={index} className="sidebar-item">
                  <NavLink
                    to={item.path}
                    className={() =>
                      `sidebar-link ${
                        activeIndex === index ? "active-parent" : ""
                      }`
                    }
                    onClick={() => {
                      setActiveIndex(index);
                      setOpenMenus({});
                    }}
                    title={!isSidebarOpen ? item.name : ""}
                  >
                    <div className="submenu-main">
                      <span className="sideNav-icon">{item.icon}</span>

                      {isSidebarOpen && (
                        <span
                          className="sideNav-label text-ellipsis"
                          title={item.name}
                        >
                          {item.name}
                        </span>
                      )}
                    </div>
                  </NavLink>
                </li>
              );
            })}
          </ul>
        ) : (
          <ul className="sidebar-menu">
            {menuItems.map((item, index) => {
              if (item.children) {
                const isOpen = openMenus[index];
                return (
                  <li key={index} className="sidebar-item nested">
                    {/* Main Item */}
                    <div
                      className={`sidebar-link submenu-header ${
                        activeIndex === index ? "active-parent" : ""
                      }`}
                      onClick={() => toggleMenu(index)}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="submenu-main">
                        <span className="sideNav-icon">{item.icon}</span>

                        {isSidebarOpen && (
                          <span
                            className="sideNav-label text-ellipsis"
                            title={item.name}
                          >
                            {item.name}
                          </span>
                        )}
                      </div>

                      {/* Arrow */}
                      {isSidebarOpen && (
                        <span className="submenu-arrow">
                          {isOpen ? <ChevronUp /> : <ChevronDown />}
                        </span>
                      )}
                    </div>
                    {/* Sub Menu */}
                    {isSidebarOpen && isOpen && (
                      <ul className="sideNav-nested-menu">
                        {item.children.map((child, i) => (
                          <li key={i}>
                            <NavLink
                              to={child.path}
                              className="nested-link"
                              onClick={() => {
                                setActiveIndex(index);
                                setOpenMenus({ [index]: true });
                              }}
                            >
                              <span className="dot">•</span> {child.name}
                            </NavLink>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                );
              }
              if (item.name === "Log Out") {
                return (
                  <li key={index} className="sidebar-item">
                    <NavLink
                      to="/login"
                      className={`sidebar-link ${
                        activeIndex === index ? "active-parent" : ""
                      }`}
                      title={!isSidebarOpen ? item.name : ""}
                      onClick={(e) => {
                        e.preventDefault();
                        dispatch(logoutUser());
                        navigate("/login");
                      }}
                    >
                      <div className="submenu-main">
                        <span className="sideNav-icon">{item.icon}</span>

                        {isSidebarOpen && (
                          <span
                            className="sideNav-label text-ellipsis"
                            title={item.name}
                          >
                            {item.name}
                          </span>
                        )}
                      </div>
                    </NavLink>
                  </li>
                );
              }
              return (
                <li key={index} className="sidebar-item">
                  <NavLink
                    to={item.path}
                    className={() =>
                      `sidebar-link ${
                        activeIndex === index ? "active-parent" : ""
                      }`
                    }
                    onClick={() => {
                      setActiveIndex(index);
                      setOpenMenus({});
                    }}
                    title={!isSidebarOpen ? item.name : ""}
                  >
                    <div className="submenu-main">
                      <span className="sideNav-icon">{item.icon}</span>

                      {isSidebarOpen && (
                        <span
                          className="sideNav-label text-ellipsis"
                          title={item.name}
                        >
                          {item.name}
                        </span>
                      )}
                    </div>
                  </NavLink>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
};

export default SideNav;

